const FatalErrorTypeEnum = Object.freeze({
    REGISTRATION: 'REGISTRATION',
    RECATEGORISATION: 'RECATEGORISATION',
    SUSPENDED: 'SUSPENDED'
});

export default FatalErrorTypeEnum;
